module.exports = __webpack_public_path__ + "img/delivery_905017_r1@2x.da5eb523.png";